"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportFileSection = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const index_1 = tslib_1.__importDefault(require("../../../../../components/FileDroppable/index"));
const index_2 = tslib_1.__importDefault(require("../../../../../components/HelpBlock/index"));
const ImportFileSection = (props) => {
    return (React.createElement(index_1.default, { loadingText: React.createElement(index_2.default, { mb: 2 }, "File loaded , file ready to be imported."), message: props.message, helpText: "Data Import", defaultText: "Click here to select a file to load, or drag it here", dragOverText: "Drop file here to start Data Import", height: "100%", fileAccept: props.supportedFileFormats, readFile: props.readFile }));
};
exports.ImportFileSection = ImportFileSection;
